var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenditureCreateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1425 2H5.8575C3.1275 2 1.5 3.6275 1.5 6.3575V12.635C1.5 15.3725 3.1275 17 5.8575 17H12.135C14.865 17 16.4925 15.3725 16.4925 12.6425V6.3575C16.5 3.6275 14.8725 2 12.1425 2ZM12 10.0625H9.5625V12.5C9.5625 12.8075 9.3075 13.0625 9 13.0625C8.6925 13.0625 8.4375 12.8075 8.4375 12.5V10.0625H6C5.6925 10.0625 5.4375 9.8075 5.4375 9.5C5.4375 9.1925 5.6925 8.9375 6 8.9375H8.4375V6.5C8.4375 6.1925 8.6925 5.9375 9 5.9375C9.3075 5.9375 9.5625 6.1925 9.5625 6.5V8.9375H12C12.3075 8.9375 12.5625 9.1925 12.5625 9.5C12.5625 9.8075 12.3075 10.0625 12 10.0625Z",
    fill: "#E8E6EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenditureCreateActive);
export default __webpack_public_path__ + "static/media/expenditure-create-active.8196d4a94a1751fb9cd7c84dd67ced77.svg";
export { ForwardRef as ReactComponent };